module.exports = __webpack_public_path__ + "static/media/loader.465f5518.gif";